export default __webpack_public_path__ + "images/header/saubere_filme_header_video.mp4";